import React from "react";
import { AuthProvider } from "../../features/account/context/AuthContext";
import { CartProvider } from "../../features/market/context/CartContext";
import { UserProfileProvider } from "../../features/account/context/UserProfileContext";
import { LocaleProvider } from "./LocaleContext";
import { RuntimeConfigProvider } from "./RuntimeConfigContext";

const AppProviders = ({ children }) => (
  <RuntimeConfigProvider>
    <LocaleProvider>
      <AuthProvider>
        <CartProvider>
          <UserProfileProvider>{children}</UserProfileProvider>
        </CartProvider>
      </AuthProvider>
    </LocaleProvider>
  </RuntimeConfigProvider>
);

export default AppProviders;
